import React from "react";

const BenchmarkTest = () => {
	return (
		<div className="container mx-auto h-screen flex items-center justify-center">
			<div className="border-2 border-yellow-500 rounded-lg p-8 text-center bg-white shadow-lg max-w-md">
				<div className="text-6xl mb-6">⚡</div>
				<h1 className="text-4xl font-bold tracking-tight mb-4">
					Benchmark Tests
				</h1>
				<p className="text-muted-foreground text-lg mb-4">
					Test your skills against standardized challenges and see how you measure up.
				</p>
				<div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
					<p className="text-yellow-800 font-medium">
						Coming Soon!
					</p>
				</div>
			</div>
		</div>
	);
};

export default BenchmarkTest;
